import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-gray-50 to-gray-90 p-8 text-center relative overflow-hidden" }
const _hoisted_2 = { class: "p-8" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-600 text-sm mt-1"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-center mt-4" }

import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import ResetHeader from "./ResetHeader.vue";
import { useMutation } from "@tanstack/vue-query";
import { forgotPasswordAction } from "../../actions/forgotPassword.actions";
import { useToast } from "vue-toastification";


export default /*@__PURE__*/_defineComponent({
  __name: 'StepEmailForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ["send-code", "go-to-login"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const toast = useToast();

const emailSchema = toTypedSchema(
  yup.object({
    email: yup
      .string()
      .trim()
      .required("Ingresa tu correo electrónico")
      .email("Correo electrónico inválido"),
  })
);

const { defineField, errors, handleSubmit } = useForm({
  validationSchema: emailSchema,
  initialValues: { email: "" },
});

const [email] = defineField("email");

const {
  mutate: sendCode,
  isPending,
} = useMutation({
  mutationFn: (emailValue: string) => forgotPasswordAction(emailValue),
  onSuccess: (_data, emailValue) => {
    emit("send-code", emailValue);
  },
  onError: (err: { message?: string }) => {
    toast.error(
      err?.message || "Error al enviar el código. Intenta nuevamente."
    );
  },
});

const emitSendCode = handleSubmit((values) => {
  sendCode(values.email);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-0 opacity-10" }, [
        _createElementVNode("div", { class: "absolute top-0 right-0 w-32 h-32 bg-cyan-500 rounded-full blur-3xl" }),
        _createElementVNode("div", { class: "absolute bottom-0 left-0 w-40 h-40 bg-pink-500 rounded-full blur-3xl" })
      ], -1)),
      _createVNode(ResetHeader, {
        title: "Nova",
        subtitle: "Innovación de ventas sin límites"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Olvidé mi contraseña", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-500 text-sm mb-6" }, " Introduce tu dirección de correo electrónico y te enviaremos un código de verificación. ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "reset-email",
          class: "block text-sm font-semibold text-slate-700 mb-2"
        }, [
          _createTextVNode(" Correo electrónico "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          id: "reset-email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
          type: "email",
          autocomplete: "email",
          placeholder: "tu@correo.com",
          class: _normalizeClass(["w-full border-2 border-gray-200 rounded-xl py-3 px-4 focus:border-slate-900 focus:outline-none transition-colors", { 'border-red-500': _unref(errors).email }])
        }, null, 2), [
          [_vModelText, _unref(email)]
        ]),
        (_unref(errors).email)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errors).email), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(emitSendCode) && _unref(emitSendCode)(...args))),
        disabled: _unref(isPending) || props.isLoading,
        class: "w-full mt-4 bg-slate-900 text-white py-3 rounded-xl font-semibold transition-all hover:bg-slate-800 disabled:bg-gray-300 disabled:cursor-not-allowed"
      }, [
        (_unref(isPending) || props.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("svg", {
                class: "animate-spin h-5 w-5 mr-2",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("circle", {
                  class: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  "stroke-width": "4"
                }),
                _createElementVNode("path", {
                  class: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                })
              ], -1),
              _createTextVNode(" Enviando... ", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "ENVIAR CÓDIGO"))
      ], 8, _hoisted_5),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-sm text-slate-600 hover:text-slate-800 transition-colors inline-flex items-center"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-arrow-left mr-2" }, null, -1),
            _createTextVNode(" Volver a Iniciar Sesión ", -1)
          ]))]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})